import React, { useState } from "react";
import { Box, Flex } from "rebass";
import Fallback from "../../icons/Fallback";
import Close from "../../icons/Close";

function ProductImage({
  img,
  width,
  height,
  removeButton,
  buttonFunction,
  scale = 1,
}) {
  const [displayCondition, setDisplayCondition] = useState(false);

  const [faultySrc, setFaultySrc] = useState(false);

  function enter() {
    setDisplayCondition(true);
  }

  function leave() {
    setDisplayCondition(false);
  }

  const imageError = !img || faultySrc;

  return (
    <Flex
      sx={{
        width: width || "300px",
        height: height || "180px",
        justifyContent: "center",
        alignItems: "center",
      }}
      onMouseEnter={enter}
      onMouseLeave={leave}
    >
      {removeButton && displayCondition && (
        <Box
          style={{
            position: "absolute",
            backgroundColor: "rgba(0,0,0,.3)",
            width: width || "300px",
            height: height || "180px",
            justifyItems: "center",
            alignItems: "center",
            display: "grid",
            zIndex: 10,
            cursor: "pointer",
          }}
          onClick={buttonFunction}
        >
          <Close></Close>
        </Box>
      )}
      <Box
        sx={{
          width: width || "180px",
          height: height || "130px",
          backgroundColor: "white",
        }}
      >
        {imageError ? (
          <Box
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <Fallback
              style={{
                objectFit: "scale-down",
                transform: `scale(.6)`,
              }}
            ></Fallback>
          </Box>
        ) : (
          <Box
            style={{
              display: "flex",
              height: "100%",
              width: "100%",
              justifyContent: "center",
              alignContent: "center",
              overflow: "hidden",
            }}
          >
            <img
              src={img}
              alt="product"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "scale-down",
                transform: "scale(" + scale + ")",
                pointerEvents: "none",
              }}
              onError={() => {
                console.log("image source error: " + img);
                setFaultySrc(true);
              }}
            ></img>
          </Box>
        )}
      </Box>
    </Flex>
  );
}

export { ProductImage };
